import { __read } from "tslib";
import * as u from './urx';
import { domIOSystem } from './domIOSystem';
import { UP, DOWN } from './stateFlagsSystem';
import { tupleComparator } from './comparators';
export var TOP = 'top';
export var BOTTOM = 'bottom';
export var NONE = 'none';
export function getOverscan(overscan, end, direction) {
    if (typeof overscan === 'number') {
        return (direction === UP && end === TOP) || (direction === DOWN && end === BOTTOM) ? overscan : 0;
    }
    else {
        if (direction === UP) {
            return end === TOP ? overscan.main : overscan.reverse;
        }
        else {
            return end === BOTTOM ? overscan.main : overscan.reverse;
        }
    }
}
function getViewportIncrease(value, end) {
    return typeof value === 'number' ? value : value[end] || 0;
}
export var sizeRangeSystem = u.system(function (_a) {
    var _b = __read(_a, 1), _c = _b[0], scrollTop = _c.scrollTop, viewportHeight = _c.viewportHeight, deviation = _c.deviation, headerHeight = _c.headerHeight, fixedHeaderHeight = _c.fixedHeaderHeight;
    var listBoundary = u.stream();
    var topListHeight = u.statefulStream(0);
    var increaseViewportBy = u.statefulStream(0);
    var overscan = u.statefulStream(0);
    var visibleRange = u.statefulStreamFromEmitter(u.pipe(u.combineLatest(u.duc(scrollTop), u.duc(viewportHeight), u.duc(headerHeight), u.duc(listBoundary, tupleComparator), u.duc(overscan), u.duc(topListHeight), u.duc(fixedHeaderHeight), u.duc(deviation), u.duc(increaseViewportBy)), u.map(function (_a) {
        var _b = __read(_a, 9), scrollTop = _b[0], viewportHeight = _b[1], headerHeight = _b[2], _c = __read(_b[3], 2), listTop = _c[0], listBottom = _c[1], overscan = _b[4], topListHeight = _b[5], fixedHeaderHeight = _b[6], deviation = _b[7], increaseViewportBy = _b[8];
        var top = scrollTop - deviation;
        var stickyHeaderHeight = topListHeight + fixedHeaderHeight;
        var headerVisible = Math.max(headerHeight - top, 0);
        var direction = NONE;
        var topViewportAddition = getViewportIncrease(increaseViewportBy, TOP);
        var bottomViewportAddition = getViewportIncrease(increaseViewportBy, BOTTOM);
        listTop -= deviation;
        listTop += headerHeight + fixedHeaderHeight;
        listBottom += headerHeight + fixedHeaderHeight;
        listBottom -= deviation;
        if (listTop > scrollTop + stickyHeaderHeight - topViewportAddition) {
            direction = UP;
        }
        if (listBottom < scrollTop - headerVisible + viewportHeight + bottomViewportAddition) {
            direction = DOWN;
        }
        if (direction !== NONE) {
            return [
                Math.max(top - headerHeight - getOverscan(overscan, TOP, direction) - topViewportAddition, 0),
                top -
                    headerVisible -
                    fixedHeaderHeight +
                    viewportHeight +
                    getOverscan(overscan, BOTTOM, direction) +
                    bottomViewportAddition,
            ];
        }
        return null;
    }), u.filter(function (value) { return value != null; }), u.distinctUntilChanged(tupleComparator)), [0, 0]);
    return {
        // input
        listBoundary: listBoundary,
        overscan: overscan,
        topListHeight: topListHeight,
        increaseViewportBy: increaseViewportBy,
        // output
        visibleRange: visibleRange,
    };
}, u.tup(domIOSystem), { singleton: true });
